import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProductAlert, StoreAlert } from '../../services/stock-alerts.service';

export interface AlertChip {
  type: 'zero-stock' | 'low-stock' | 'expiration' | 'low-rotation';
  label: string;
  class: string;
}

@Component({
  selector: 'app-stock-alert-chips',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="alert-chips">
        <div *ngFor="let alert of getActiveAlerts()" 
           class="chip" 
           [ngClass]="alert.class">
        <div class="alert-icon">!</div>
        <span class="alert-label">{{ alert.label | translate }}</span>
      </div>
    </div>
  `,
  styleUrls: ['./stock-alert-chips.component.scss']
})
export class StockAlertChipsComponent {
  @Input() productAlert: ProductAlert | null = null;
  @Input() currentStoreId?: number;

  constructor(private translate: TranslateService) {}

  getActiveAlerts(): AlertChip[] {
    if (!this.productAlert || !this.productAlert.hasAlertsTriggered) {
      return [];
    }

    const alerts: AlertChip[] = [];
    const alertsMap = new Map<string, AlertChip>();
    this.productAlert.storeAlerts.forEach(store => {
      if (this.currentStoreId && store.storeId !== this.currentStoreId) {
        return;
      }      if (store.triggersZeroStockAlert) {
        const key = 'zero-stock';
        if (!alertsMap.has(key)) {
            alertsMap.set(key, {
            type: 'zero-stock',
            label: 'pages.stock.table.stock_alert_chips.zero_stock',
            class: 'chip-red'
          });
        }
      }

      if (store.triggersLowStockAlert) {
        const key = 'low-stock';
        if (!alertsMap.has(key)) {
            alertsMap.set(key, {
            type: 'low-stock',
            label: 'pages.stock.table.stock_alert_chips.low_stock',
            class: 'chip-yellow'
          });
        }
      }

      if (store.triggersExpirationAlert) {
        const key = 'expiration';
        if (!alertsMap.has(key)) {
            alertsMap.set(key, {
            type: 'expiration',
            label: 'pages.stock.table.stock_alert_chips.expiration',
            class: 'chip-blue'
          });
        }
      }

      if (store.triggersLowRotationAlert) {
        const key = 'low-rotation';
        if (!alertsMap.has(key)) {
            alertsMap.set(key, {
            type: 'low-rotation',
            label: 'pages.stock.table.stock_alert_chips.low_rotation',
            class: 'chip-purple'
          });
        }
      }
    });
    return Array.from(alertsMap.values());
  }
}
